import React from 'react';
import { LogoImage } from '../../shared/DataStructures/CompanyLogos';
import { styled } from '../../style';

interface CompanyImageProps {
  image: LogoImage;
}

export function CompanyImage({ image }: CompanyImageProps) {
  return (
    <Image
      src={image.src}
      onError={(e: any) => {
        e.target.style.display = 'none';
      }}
    />
  );
}

const Image = styled.img`
  max-width: 300px;
  max-height: 32px;
`;
